
import '@/components/page-loading'
export default {
  components: {
    'bvip-tips-dialog': () => import('../components/bvip-tips-dialog.vue'),
    'bvip-action-sheet': () => import('../components/bvip-action-sheet/index.vue')
  },
  computed: {
    renderConfig () {
      if (this.checkGreatVIP === 'Y') {
        return this.complianceConfig?.checked
      } else if (this.checkGreatVIP === 'N') {
        return this.complianceConfig?.uncheck
      } else {
        return {}
      }
    },
    // 购买须知
    showDialogTips () {
      return (this.mustCheck && this.checkGreatVIP === 'Y' && this.renderConfig?.popUp === 'Y') || (this.userInfo.sj === 'Y' && this.checkGreatVIP === 'Y')
    },
    // 样式A/B
    style () {
      if (this.mustCheck && this.checkGreatVIP === 'N') {
        return this.renderConfig?.click
      }
      return null
    },
    // 是否引导购买
    unCheckLead () {
      return this.mustCheck && this.checkGreatVIP === 'N' && this.renderConfig?.lead === 'Y'
    },
    cantWithdraw () {
      return this.mustCheck && this.checkGreatVIP === 'N' && this.style === 'A'
    }
  },
  data () {
    return {
      bBvipTipsVisible: false,
      bvipActionSheetVisible: false,
      mustCheck: false,
      complianceConfig: {
        defaultCheck: '', // 是否默认勾选
        checked: { // 勾选配置
          popUp: '', // 是否弹窗
          click: '', // 点击提现按钮样式（AB）
          lead: '' // 是否引导大权益购买流程
        },
        uncheck: { // 未勾选配置
          popUp: '',
          click: '', 
          lead: '' 
        }
      }
    }
  },
  mounted () {
 
  },
  methods: {
    showStyleB () {
      this.$indicator()
      setTimeout(() => {
        this.$indicator.close()
        this.$message('今日额度已抢完，请明日再试')
      }, 2000)
    }
  }
}